var exports = {
  "Y": "xfd349460--b86294--tooltip",
};

module.exports = exports;
